<template>
  <div id="app">
    <div id="hni-vertical">
      <h1>Het Nieuwe Instituut</h1>
    </div>

    <!-- router content will be inserted here -->
    <router-view></router-view>

      <Logs/>
  </div>
</template>

<script>
import Logs from './components/Logs'

export default {
  name: 'App',
  components: {
    Logs
  }
}
</script>

<style lang="css">
 #app {
   position:absolute;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   text-align: center;
   background-color: var(--default-main-bg-color);
   margin:0;
   padding:0;
   width: 100%;
   height:100%;
   /* to be set back to hidden since this will become an animation */
   overflow:visible;
 }

 .box {
   border: 1px solid gray;
 }

 #logged_in {
   position:relative;
   top:0px;
   width:100%;
   height:100%;
 }

 #hni-vertical {
  position:absolute;
  top:50vh;
  transform-origin: 15% 50%;
  transform: rotate(270deg);
  z-index:5;
 }


div.blocks {
  border: 3px solid transparent;
}

@media only screen and (max-width: 800px) {
  li {
    width:100%;
    }
}

</style>
